import { render, staticRenderFns } from "./movebar.vue?vue&type=template&id=14caaa3e&"
import script from "./movebar.vue?vue&type=script&lang=js&"
export * from "./movebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports